export default {
      id: "smooth-cross-usage",
      viewBox: "0 0 18 18",
      url: "/" + "img/marilyn-ui.svg#smooth-cross",
      toString: function () {
        return this.url;
      }
    }